// extracted by mini-css-extract-plugin
export default {"container":"container--BHtm9","inside-row":"inside-row--WBjjq"};